import { handleActions } from 'redux-actions';
import { PapiDaSharedUserSendotp, PapiRequestDaSharedUserSendotp } from '@wix/da-papi-types';
import { networkRequestMetaReducer } from '../networking/utils';
import { reduxKey } from './constants';
import { defaultOneTimePasswordState } from './defaults';
import { OneTimePasswordStoreSlice } from './types';
import {
  sendOneTimePasswordRequest,
  sendOneTimePasswordRequestFailure,
  sendOneTimePasswordRequestSuccess,
} from './actions';

const reducers = handleActions<OneTimePasswordStoreSlice, any>(
  {
    ...networkRequestMetaReducer<
      PapiRequestDaSharedUserSendotp,
      PapiDaSharedUserSendotp,
      {},
      OneTimePasswordStoreSlice
    >({
      initialAction: sendOneTimePasswordRequest,
      successAction: sendOneTimePasswordRequestSuccess,
      failureAction: sendOneTimePasswordRequestFailure,
      additionalStateUpdates: {
        initialStateUpdate: (state, action) => ({
          requestCount: state.requestCount + 1,
        }),
      },
    }),
  },
  defaultOneTimePasswordState
);

export default {
  [reduxKey]: reducers,
};
